import React from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import useTooltipStyles from './useStyles';

type FeatureTooltipProps = {
  tooltipHeading: string;
  tooltip: string;
};

export default function FeatureTooltip({ tooltipHeading, tooltip }: FeatureTooltipProps): React.ReactElement {
  const { Tooltip, TooltipArrow } = useTooltipStyles();

  return (
    <Box className={Tooltip}>
      <Typography component="h5" variant="body" data-testid="Tooltip__Heading" className="test">
        {tooltipHeading}
      </Typography>
      {tooltip}
      <span className={TooltipArrow} />
    </Box>
  );
}
